import { CanActivate, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { AuthService } from '../services/auth.service';

@Injectable()
export class AnonymousGuard implements CanActivate {
  constructor(
    private authService: AuthService, 
    private router: Router
    ) {}

  canActivate(): Observable<boolean> {
    return this.authService.isLoggined().pipe(
      mergeMap((isLoginned: boolean) => {
        if (isLoginned) {
          this.router.navigateByUrl('/inbox/current');
        }

        return of(!isLoginned);
      }),
    );
  }
}
